import { RefreshCcw } from "lucide-react";
import { MAX_TOTAL, ROUND_COUNT } from "../color";
import { copy } from "../copy";

type Phase = "intro" | "playing" | "reviewing" | "done";

export function GameBar({
  phase,
  roundIndex,
  total,
  best,
  onRestart,
}: {
  phase: Phase;
  roundIndex: number;
  total: number;
  best: number;
  onRestart: () => void;
}) {
  const reviewBoost = phase === "reviewing" ? 1 : 0.5;
  const completedRounds =
    phase === "done"
      ? ROUND_COUNT
      : phase === "intro"
        ? 0
        : Math.min(roundIndex + reviewBoost, ROUND_COUNT);
  const progress = Math.round((completedRounds / ROUND_COUNT) * 100);
  const label =
    phase === "done"
      ? copy.complete
      : phase === "reviewing"
        ? `${roundIndex + 1} / ${ROUND_COUNT} ${copy.round} · ${copy.reviewTitle}`
        : `${roundIndex + 1} / ${ROUND_COUNT} ${copy.round}`;

  return (
    <header className="gamebar" aria-label="진행 상태">
      <div className="gamebar-row">
        <div className="gamebar-info">
          <span className="gamebar-label">{label}</span>
          <strong>
            {total}
            <small>/{MAX_TOTAL}</small>
          </strong>
        </div>
        <div className="gamebar-actions">
          <span className="gamebar-best">
            {copy.bestScore} {best}
          </span>
          <button onClick={onRestart} aria-label={copy.newGame}>
            <RefreshCcw size={16} />
            {copy.newGame}
          </button>
        </div>
      </div>
      <div
        className="gamebar-progress"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={progress}
      >
        <span style={{ width: `${progress}%` }} />
      </div>
    </header>
  );
}
